import { render } from "./PremiumTooltip.vue?vue&type=template&id=0cf31010"
import script from "./PremiumTooltip.vue?vue&type=script&lang=js"
export * from "./PremiumTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__